import { CircleCheckBig } from "lucide-react";
import { toast } from "../../components/ui/use-toast";
import axios from "axios";
const baseURL = process.env.REACT_APP_SERVER_URL;

export const getAllUsers = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseURL}/api/auth`, config);
    return { users: response.data.users };
  } catch (error) {
    console.error(error);
  }
};

export const deleteUser = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.delete(`${baseURL}/api/auth/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getUserById = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseURL}/api/auth/${id}`, config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateUser = async (
  id: number,
  formData: any,
  router: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.patch(
      `${baseURL}/api/auth/${id}`,
      formData,
      config
    );
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: "User updated ...",
      className: "bg-green-500 border border-green-500",
    });
    router("/admin-dashboard/utilisateurs");
    return response.data;
  } catch (error: any) {
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: error?.response?.data?.message,
      className: "bg-red-500 border border-red-500",
    });
  }
};

export const updatePassword = async (data: any, router: Function) => {
  try {
    const response = await fetch(`${baseURL}/api/auth/change-pwd`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(data),
    });

    const resData = await response.json();

    if (!response.ok) throw new Error(resData.message);

    toast({
      variant: "destructive",
      description: "Le mot de passe a été modifié avec succès.",
      className: "bg-green-500 border border-green-500",
    });

    setTimeout(() => {
      router(0);
    }, 800);
  } catch (error: any) {
    toast({
      variant: "destructive",
      description: error.message || "Il y a eu un problème avec votre requête.",
    });
  }
};

export const userNewPassword = async (
  data: any,
  token: any,
  router: Function
) => {
  try {
    const response = await fetch(`${baseURL}/api/auth/new-pwd`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        newPassword: data?.newPassword,
        token,
      }),
    });

    const resData = await response.json();

    if (!response.ok) throw new Error(resData.message);

    toast({
      variant: "destructive",
      description: "Le mot de passe a été modifié avec succès.",
      className: "bg-green-500 border border-green-500",
    });

    setTimeout(() => {
      router("/login");
    }, 800);
  } catch (error: any) {
    toast({
      variant: "destructive",
      description: error.message || "Il y a eu un problème avec votre requête.",
    });
  }
};

export const userResetPassword = async (data: any, router: Function) => {
  try {
    const response = await fetch(`${baseURL}/api/auth/forget-pwd`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: data?.email,
      }),
    });

    const resData = await response.json();

    if (!response.ok) throw new Error(resData.message);

    toast({
      variant: "destructive",
      description: "Vérifiez votre adresse e-mail.",
      className: "bg-green-500 border border-green-500",
    });
  } catch (error: any) {
    toast({
      variant: "destructive",
      description: error.message || "Il y a eu un problème avec votre requête.",
    });
  }
};
